export default __webpack_public_path__ + "static/media/oneport.203ca27f.png";